export default "__VITE_ASSET__4f88a8a1__"